import React from 'react';
import { Select } from 'semantic-ui-react';
import styled from 'styled-components';
import { LoadingBar, StatTable } from 'components/Commons';

const BookingDateResult = ({ contents }) => {
  const header = [
    { content: '제휴점명', textAlign: 'left', maxWidth: '35%' },
    { content: '메뉴명', textAlign: 'left', maxWidth: '35%' },
    { content: '예약', textAlign: 'center', maxWidth: '10%' },
    { content: '예약 취소', textAlign: 'center', maxWidth: '10%' },
    { content: '결제 완료', textAlign: 'center', maxWidth: '10%' }
  ];

  let tabledata = null;
  let totalCounts = null;
  let booking = 0;
  let canceled = 0;
  let complete = 0;

  if (contents && contents.length > 0) {
    const newData = contents.map((content) => {
      const headerArr = [];
      const bodyArr = [];
      let obj = {};

      headerArr.push({
        content: content.bookingGroup.name,
        colSpan: 5,
        textAlign: 'left'
      });
      const { stores = [] } = content;
      const newStore = {};

      stores.forEach((store) => {
        const sId = store.id;

        if (newStore[sId]) return;

        const { menus: storeData = [] } = store;

        newStore[sId] = storeData;

        storeData.forEach((item, idx) => {
          const { name, count } = item;
          const rows = {
            row: [
              { content: idx === 0 ? store.name : null, textAlign: 'left', maxWidth: '35%' },
              { content: name, textAlign: 'left', maxWidth: '35%' },
              { content: count.booking, textAlign: 'center', maxWidth: '10%' },
              { content: count.canceled, textAlign: 'center', maxWidth: '10%' },
              { content: count.payment, textAlign: 'center', maxWidth: '10%' }
            ]
          };

          booking += count.booking;
          canceled += count.canceled;
          complete += count.payment;

          bodyArr.push(rows);
        });
      });

      obj = {
        header: headerArr,
        body: bodyArr
      };
      return obj;
    });

    totalCounts = [
      { content: '합계', textAlign: 'left', colSpan: 2 },
      { content: booking, textAlign: 'center', maxWidth: '10%' },
      { content: canceled, textAlign: 'center', maxWidth: '10%' },
      { content: complete, textAlign: 'center', maxWidth: '10%' }
    ];

    tabledata = newData;
  } else {
    tabledata = '예약 목록이 없습니다.';
  }

  let loading = '';
  if (!tabledata) {
    loading = <LoadingBar />;
  }

  return (
    <GridRowStyled className="table-container">
      {loading}
      <GridRowStyled columns={12}>
        <div className="table-box">
          <StatTable colWidth={[200, 300, 100, 100, 100]} header={header} data={tabledata} footer={totalCounts} />
        </div>
      </GridRowStyled>
    </GridRowStyled>
  );
};

const GridRowStyled = styled.div`
  &&&& {
    width: 100%;
    padding-top: 0;
    & tbody th {
      font-size: 12px;
      color: #4b4b4b;
      font-weight: normal;
    }
  }
`;

const SelectStyled = styled(Select)`
  &&&& {
    position: absolute;
    top: 0;
    right: 1rem;
  }
`;

export default BookingDateResult;
